module.exports = "../images/icons/jpg.svg";